if (!customElements.get('community-reviews-swiper')) {
  customElements.define(
    'community-reviews-swiper',
    class CommunityReviewsSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.sectionId = this.getAttribute('data-section-id');
        this.initTimeout = null;
        this.handleClick = this.handleClick.bind(this);
        this.onSectionLoad = this.onSectionLoad.bind(this);
        this.onSectionUnload = this.onSectionUnload.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.handleClick);
        this.init();
        document.addEventListener('shopify:section:load', this.onSectionLoad);
        document.addEventListener('shopify:section:unload', this.onSectionUnload);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
        document.removeEventListener('shopify:section:unload', this.onSectionUnload);
        if (this.initTimeout) {
          clearTimeout(this.initTimeout);
          this.initTimeout = null;
        }
        this.destroySwiper();
      }

      onSectionLoad(event) {
        if (event?.detail?.sectionId !== this.sectionId) return;
        this.destroySwiper();
        this.init();
      }

      onSectionUnload(event) {
        if (event?.detail?.sectionId !== this.sectionId) return;
        this.destroySwiper();
      }

      handleClick(event) {
        const link = event.target.closest('a[data-community-reviews-smooth-scroll="true"]');
        if (!link || !this.contains(link)) return;

        const href = link.getAttribute('href');
        if (!href) return;

        let url;
        try {
          url = new URL(href, window.location.href);
        } catch (e) {
          return;
        }

        if (!url.hash || url.hash.length < 2) return;

        const current = new URL(window.location.href);
        const isSamePage =
          url.origin === current.origin && url.pathname === current.pathname && url.search === current.search;
        if (!isSamePage) return;

        let targetId;
        try {
          targetId = decodeURIComponent(url.hash.slice(1));
        } catch (e) {
          targetId = url.hash.slice(1);
        }

        // eslint-disable-next-line compat/compat
        const target = document.getElementById(targetId) || document.querySelector(`#${CSS.escape(targetId)}`);
        if (!target) return;

        event.preventDefault();

        const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
        const behavior = prefersReducedMotion ? 'auto' : 'smooth';

        const bodyPaddingTop = Number.parseFloat(window.getComputedStyle(document.body).paddingTop) || 0;
        const stickyHeader = document.querySelector('.header-sticky');
        const stickyHeaderHeight = stickyHeader?.getBoundingClientRect?.().height || 0;
        const offset = Math.max(bodyPaddingTop, stickyHeaderHeight);

        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const top = Math.max(0, targetTop - offset);

        window.scrollTo({ top, behavior });
      }

      init(attempt = 0) {
        if (this.initTimeout) {
          clearTimeout(this.initTimeout);
          this.initTimeout = null;
        }

        const swiperEl = this.querySelector('[data-community-reviews-swiper]');
        if (!swiperEl) return;

        // Prevent duplicate swiper initialization
        if (swiperEl.classList.contains('swiper-initialized')) return;

        if (!window.Swiper) {
          if (attempt < 30) {
            this.initTimeout = setTimeout(() => this.init(attempt + 1), attempt === 0 ? 0 : 100);
          }
          return;
        }

        const slidesDesktop = parseFloat(this.dataset.slidesDesktop || '3.5');
        const slidesMobile = parseFloat(this.dataset.slidesMobile || '1.3');

        const prevArrowEl = this.querySelector('.community-reviews-swiper__arrow--prev');
        const nextArrowEl = this.querySelector('.community-reviews-swiper__arrow--next');

        this.swiper = new Swiper(swiperEl, {
          slidesPerView: slidesMobile,
          slidesPerGroup: 1,
          spaceBetween: 10,
          slidesOffsetAfter: 20,
          loop: false,
          grabCursor: true,
          speed: 300,
          navigation: {
            prevEl: prevArrowEl,
            nextEl: nextArrowEl,
          },
          breakpoints: {
            768: {
              slidesPerView: slidesDesktop,
              spaceBetween: 15,
              slidesOffsetAfter: 0,
            },
            1024: {
              slidesPerView: slidesDesktop,
              spaceBetween: 20,
              slidesOffsetAfter: 0,
            },
          },
          observer: true,
          observeParents: true,
        });
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }
  );
}


